import {writable} from 'svelte/store'

export const ModuleStore = writable({
    "name": "Waifu2x_Image_Upscaler2", 
    "description": "This module leverages Waifu2x package to upscale images", 
    "tags": ["image_upscaling", "computer_vision"], 
    "input": "full path to input image (jpg, png)",
    "output": "full path to output image (jpg, png)",
    "download_link": ""
})

export const AccountInfoStore = writable({
    "username": "", 
    "password": "", 
    "coins": 0,
    "accessToken": "",
    "loginStatus": false,
    "patreon_email": "",
    "patreon_username": ""
})

export const ProductInfoStore = writable({
    "name": "", 
    "price": "", 
    "imageTitle": "",
    "description": "",
    "downloadLink": ""
})


export const PaymentStatusStore = writable({
    "success": false
})
